var path = '/pages/dashboard/directives/dashboard-tabular-simple-directive.tpl.html';
var html = "<table class=\"table table-muted\">\n    <thead>\n        <tr>\n            <th style=\"width: 60%;\">{{ctrl.headline}}</th>\n            <th style=\"width: 40%;\"></th>\n        </tr>\n    </thead>\n    <tbody>\n    \t<tr ng-repeat=\"(group, count) in ctrl.data\" ng-if=\"!ctrl.skipEmpty || count > 0\">\n\t\t\t<td>{{group ? group : (ctrl.empty || 'unknown')}}</td>\n\t\t\t<td>{{count}} {{ctrl.unit}}</td>\n\t\t</tr>\n    </tbody>\n</table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/directives/dashboard-tabular-simple-directive.tpl.html
// module id = 2239
// module chunks = 1